<ng-template #offerTemplate>

  <div *ngIf="config?.theme" class="offer-card theme-{{config?.theme}}" [ngClass]="{'offer1' : globalVar?.dm_slabs_AB && !params?.utm_source?.includes('f2f')}">
    <div *ngIf="step===1" class="step-1">
      <div class="banner">
        <img src="/assets/images/piggy-bank-1.png" alt="offer" />
      </div>
      <div class="desc">
        <div class="heading">Claim <app-currency-icon [currency]="'INR'"></app-currency-icon>{{offerAmount}} more!</div>
        <div class="text">Join monthly giving and <app-currency-icon [currency]="'INR'"></app-currency-icon>{{offerAmount}} will be added to your SIP Subcription.</div>
      </div>
      <div class="claim-btn">
        <button (click)="applyCoupon()" mat-raised-button>Claim Now</button>
        <div class="not-now" (click)="closeDialog()">Not now</div>
      </div>
    </div>
    <div *ngIf="step===2" class="step-2">
      <div class="banner">
        <app-success-animated-load></app-success-animated-load>
      </div>
      <div class="desc">
        <div class="heading">Yay! Offer Redeemed</div>
      </div>
    </div>
  </div>

  <div *ngIf="!config?.theme">
    <div class="cross" (click)="closeDialog()">
      <mat-icon> close</mat-icon>
    </div>
    <div class="top-container">
      <div class="star-container d-flex justify-content-center align-items-center" [ngClass]="starImage">
        <div *ngIf="btnClickCount > 0" class="offer-amount">
          <strong>
            <app-currency-icon [currency]="'INR'"></app-currency-icon>{{offerAmount}}
          </strong>
        </div>
      </div>
      <div class="Heading"><h1 class="text-center">{{title}}</h1></div>
      <div class="secondary-text">
        <p class="text-center"><strong>{{subTextBold}}</strong> {{subTextNormal}}</p>
      </div>
    </div>
    <div class="seperator"></div>
    <div class="btn-container">
      <div class="white-spot white-spot-left"></div>
      <div class="white-spot white-spot-right"></div>
      <button mat-raised-button (click)="changeValues()">{{ btnText }}</button>
    </div>
  </div>
</ng-template>
